/* TrustSignalsSection.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _10 = "@media (min-width:48rem){._1svyl6l0{margin-bottom:var(--ds-space-300)}}";
const _9 = "._otyrxjmg{margin-bottom:var(--ds-space-200)}";
const _8 = "._y3gn1h6o{text-align:center}";
const _7 = "@media (min-width:64rem){._1rqt16hb{grid-template-columns:repeat(3,1fr)}._pdlmhiv4{gap:var(--ds-space-400)}._10jx1es0{max-width:858pt}._dbjg1wug{margin-top:auto}._1hvk1wug{margin-right:auto}._isu41wug{margin-bottom:auto}._15qm1wug{margin-left:auto}}";
const _6 = "@media (min-width:48rem) and (max-width:63.99rem){._1da7fsjm{grid-template-columns:repeat(2,1fr)}._1gzvl6l0{gap:var(--ds-space-300)}}";
const _5 = "._zulpl6l0{gap:var(--ds-space-300)}";
const _4 = "._yv0e1ttp{grid-template-columns:repeat(1,1fr)}";
const _3 = "._1e0c11p5{display:grid}";
import { media } from '@atlaskit/primitives/responsive';
import { BodyLarge, H3 } from '@atlassian/mpac-primitives';
import React from 'react';
import { trustSignals } from './constants';
import { TrustSignalCard } from './TrustSignalCard';
const _2 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _ = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const Description = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkpxbi _syaz1k3w", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
export const TrustSignalsWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c11p5 _yv0e1ttp _zulpl6l0 _1da7fsjm _1gzvl6l0 _1rqt16hb _pdlmhiv4 _10jx1es0 _dbjg1wug _1hvk1wug _isu41wug _15qm1wug", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  TrustSignalsWrapper.displayName = 'TrustSignalsWrapper';
}
export const SectionHeader = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_8, _9, _10]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_y3gn1h6o _otyrxjmg _1svyl6l0", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SectionHeader.displayName = 'SectionHeader';
}
export const TrustSignalsSection = () => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(H3, null, "Unlock endless possibilities with apps"), /*#__PURE__*/React.createElement(Description, null, "Delve into our extensive repository of apps, supported by our partners; and bolster your growth with Atlassian ecosystem.")), /*#__PURE__*/React.createElement(TrustSignalsWrapper, null, trustSignals.map(trustSignal => {
    const {
      id,
      stats,
      label,
      cardStyles,
      statsStyles
    } = trustSignal;
    return /*#__PURE__*/React.createElement(TrustSignalCard, {
      key: id,
      stats: stats,
      label: label,
      cardStyles: cardStyles,
      statsStyles: statsStyles
    });
  })));
};